import { render, staticRenderFns } from "./TheContacts.vue?vue&type=template&id=a9eba1f6&scoped=true&"
import script from "./TheContacts.vue?vue&type=script&lang=js&"
export * from "./TheContacts.vue?vue&type=script&lang=js&"
import style0 from "./TheContacts.vue?vue&type=style&index=0&id=a9eba1f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9eba1f6",
  null
  
)

export default component.exports